import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=8f0e7dc4&"
import script from "./Clock.vue?vue&type=script&lang=js&"
export * from "./Clock.vue?vue&type=script&lang=js&"
import style0 from "./Clock.vue?vue&type=style&index=0&lang=scss&global=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports